import { createAction } from 'redux-act';

import Country from '../../../models/interfaces/Country';
import FetchPayload from '../FetchPayload';
import TimestampPayload from '../TimestampPayload';

export const fetchCountries = createAction<FetchPayload>('FETCH_COUNTRIES_STATE');

export interface CountriesFetchedPayload extends TimestampPayload {
  countries: Country[];
}

export const countriesFetched = createAction<CountriesFetchedPayload>('COUNTRIES_STATE_FETCHED');
export const countriesFetchFailed = createAction<TimestampPayload>('COUNTRIES_STATE_FETCH_FAILED');
